import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Gallery.css";

export default function Gallery() {
  const [index, setIndex] = useState(null);
  return (
    <div className="gallery">
      <h3>Gallery</h3>
      <h1 className="mb2">School's Photos & Memories </h1>
      <div className="grid gridFr galleryContainer ">
        {[...Array(8)].map((x, i) => (
          <img
            key={i}
            src={require(`../../Assets/gallery/${i + 1}.jpg`).default}
            alt=""
            onClick={() => setIndex(i + 1)}
          />
        ))}
      </div>
      <Link
        to="/gallery"
        style={{ display: "flex", justifyContent: "center", marginTop: "2rem" }}
      >
        <button className="bt ripple" style={{ padding: "0rem 1.5rem" }}>
          View All Images
        </button>
      </Link>
      {index && (
        <div className="liteBox" onClick={() => setIndex(null)}>
          <img
            src={require(`../../Assets/gallery/${index}.jpg`).default}
            alt=""
          />
        </div>
      )}
    </div>
  );
}
